import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/process/ProcessPage.tsx");
